import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class VendorService {

  private url: string;
  private token: string;

  constructor(private http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = this.getToken();
  }

  newVendor(vendor: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    
    const authorization = `authorization=${this.token}&json=${encodeURIComponent(JSON.stringify(vendor))}`;
    
    return this.http.post<any>(`${this.url}/user/new`, authorization, { headers });
  }

  getVendors(type: string = 'ALL', activos: any = 1): Observable<any[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    const params = new HttpParams()
      .append('page', '1')
      .append('perpage', 'ALL');

    const json = { active: String(activos) };
    const authorization = `authorization=${this.token}&json=${encodeURIComponent(JSON.stringify(json))}`;
    
    return this.http.post<any[]>(`${this.url}/user/alllist/${type}`, authorization, { params, headers })
      .pipe(
        map(response => response['data'] || [])
      );
  }

  petition(url, json = null, type = null) {
    let params = "authorization=" + this.token;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + "&json=" + json;
    }

    if (type != null) {
      params = params + "&type=" + type;
    }

    return this.http.post(url, params, { headers: headers }).pipe(
      map((res: any) => {
        /*if (res.code === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }*/
        return res;
      })
    );
  }
  getOnlyVendors( activos: any = 1,    page:any = 1,
    perPage:any = 10, filtros = [] ,    task:any,
    order:any): Observable<any> {

    let url = this.url + "/user/listonlyvendor?page=" + page + "&perpage=" + perPage;
/*     const params = new HttpParams()
      .append('page', page)
      .append('perpage', perpage); */

    const json = { active: String(activos),sort:task, order:order };
/*     const authorization = `authorization=${this.token}&json=${encodeURIComponent(JSON.stringify(json))}`; */
    
  for (let filtro of filtros) {      
    if (filtro && filtro.value) {
      console.log(filtro.key);
      url = url + "&" + filtro.key + "=" + encodeURIComponent(filtro.value);

      if (filtro.type) {
        url = url + "&" + filtro.key_type + "=" + filtro.type;
      }
    }
  }
  return this.petition(url, json);
  }

  getstatevendor(token, page = null,perpage=null, data,filtros: any[] = []): Observable<any> {
    let url = `${this.url}/user/liststateuser?page=${page}&perpage=${perpage}`;

    
    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        
        url += `&${filtro.key}=${filtro.value}`;
  
        
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }
  
   
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
  
    
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  
   
    return this.http
      .post<any>(url, params, { headers })
      .pipe(map((res) => res));
  }

  getstatevendorTable(token, page = null,perpage=null, data,filtros: any[] = []): Observable<any> {
    let url = `${this.url}/user/liststateuserbytable?page=${page}&perpage=${perpage}`;

    
    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        
        url += `&${filtro.key}=${filtro.value}`;
  
        
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }
  
   
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
  
    
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  
   
    return this.http
      .post<any>(url, params, { headers })
      .pipe(map((res) => res));
  }

  getcity(token, page = null,perpage=null, data,filtros: any[] = []): Observable<any> {
    let url = `${this.url}/user/listcitybyvendor?page=${page}&perpage=${perpage}`;

    
    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        
        url += `&${filtro.key}=${filtro.value}`;
  
        
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }
  
   
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
  
    
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  
   
    return this.http
      .post<any>(url, params, { headers })
      .pipe(map((res) => res));
  }
  
  activeVendor(id: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    
    const authorization = `authorization=${this.token}`;

    return this.http.post<any>(`${this.url}/user/remove/${id}`, authorization, { headers });
    
    /*return this.http.post<any>(`${this.url}/user/remove/${id}`, authorization, { headers })
      .pipe(
        map(response => response['data'] || null)
      );*/
  }

  updateMultiple(token: any, task: any): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(task));
    let params = "authorization=" + token + "&json=" + json;
/*     const params = {
      json: JSON.stringify(task),
      authorization: token,
    }; */
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this.http.post<any>(
      `${this.url}/user/removeMultipleUsers`, params, { headers })
  }

  private getToken(): string | null {
    const token = JSON.parse(localStorage.getItem('token'));

    if (token !== 'undefined') {
      return token;
    } else {
      return null;
    }
  }
}
